import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './normsAdmission.component.html',
	styleUrls: ['./normsAdmission.component.css']
})

export class NormsAdmissionComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/admission/normsAdmission.component.ts